import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import {
  Autocomplete,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import {
  availableProductsCodeAndTypes,
  getAllProductsWithoutPagination,
  getSale,
  verifySaleTheProduct,
} from "../../../redux/features/assetManagementSlice";
import {
  CancelButton,
  SubmitButton,
} from "../../../components/mui/Buttons/Buttons";
import Checkbox from "@mui/material/Checkbox";
import { Icon } from "@iconify/react/dist/iconify.js";


const VerifyAndSale = ({
  row,
  dispatchParams,
  notPendingStage,
}) => {
  const [open, setOpen] = useState(false);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, productSerialData } = useSelector(
    (store) => store.assetmanagement
  );

  useEffect(() => {
    if (open && row?.subCategoryId) {
      dispatch(availableProductsCodeAndTypes(row?.subCategoryId));
    }
  }, [open, row?.subCategoryId]);

  const initialValues = {
    purchaseID: "",
    verified: false,
    product_id:""
  };

  const schema = Yup.object({
    verified: Yup.boolean().oneOf([true], "Verification is required"),
    purchaseID:Yup.number().required('Please Choose')
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { ...values };
      if (row) {
        const updateData = { ...data, id: row.salesID };
        dispatch(verifySaleTheProduct(updateData)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getSale(dispatchParams));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });

  const handleProductChange = (event, option) => {
    const fieldName = event.target?.id.split("-")[0];
    formik.setFieldValue(fieldName, option?.purchaseID);
    formik.setFieldValue('product_id', option?.product_id);

  };

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <GlobalDialog
      maxWidth={"xs"}
      fullWidth
      title={"Verify And Deliver"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            size="small"
            disabled={row?.isProcurementHeadApproved !==1 || notPendingStage}
            variant="outlined"
            onClick={() => setOpen(true)}
          >
            Verify And Deliver
          </Button>
        </>
      }
      content={
        <Box>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Box
                  component={Paper}
                  elevation={3}
                  p={2}
                  borderRadius={2}
                  sx={{ maxWidth: 400 }}
                >
                  <Stack spacing={1.5}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      Order Details
                    </Typography>

                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Icon
                        icon="icon-park-solid:people"
                        width="22"
                        height="22"
                        style={{ color: "#7e4d8b" }}
                      />
                      <Typography variant="body1">{row.buyerName}</Typography>
                    </Stack>

                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Icon
                        icon="mdi:cart"
                        width="22"
                        height="22"
                        style={{ color: "#7e4d8b" }}
                      />
                      <Typography variant="body1">
                         Item : {row.subCategoryName}
                      </Typography>
                    </Stack>

                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Icon
                        icon="fluent:book-number-16-filled"
                        width="22"
                        height="22"
                        style={{ color: "#7e4d8b" }}
                      />
                      <Typography variant="body1">
                        Quantity: {row.count}
                      </Typography>
                    </Stack>

                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Icon
                        icon="material-symbols:date-range"
                        width="22"
                        height="22"
                        style={{ color: "#7e4d8b" }}
                      />
                      <Typography variant="body1">
                        Requested On:{" "}
                        {new Date(row.createdAt).toLocaleDateString()}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
                <Box
                  mt={2}
                  component={Paper}
                  elevation={2}
                  p={2}
                  borderRadius={2}
                >
                  <Typography variant="h6" gutterBottom>
                    Verification
                  </Typography>

                 
                    <Box>
                      <Autocomplete
                        disabled={loading}
                        name="purchaseID"
                        id="purchaseID"
                        options={productSerialData}
                        getOptionLabel={(option) =>
                          option.productSerialCode || option.product_name || ""
                        }
                        value={
                          productSerialData?.find(
                            (syllabus) =>
                              syllabus.purchaseID == formik.values.purchaseID
                          ) || null
                        }
                        onChange={handleProductChange}
                        renderInput={(params) => (
                          <TextField
                            disabled
                            fullWidth
                            autoComplete="off"
                            {...params}
                            label="Product Code"
                            error={
                              formik.touched.purchaseID &&
                              Boolean(formik.errors.purchaseID)
                            }
                            helperText={
                              formik.touched.purchaseID &&
                              formik.errors.purchaseID
                            }
                          />
                        )}
                      />
                    </Box>
                  

                  <Stack direction={"row"} alignItems="center" spacing={1}>
                    <Icon
                      icon="arcticons:okta-verify"
                      width="25"
                      height="25"
                      style={{ color: "#7e4d8b" }}
                    />
                    <Box>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="verified"
                              checked={formik.values.verified}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              color="primary"
                            />
                          }
                          label="Verified"
                          sx={{ alignItems: "center" }}
                        />
                      </FormGroup>
                    </Box>
                  </Stack>
                  {formik.touched.verified && formik.errors.verified && (
                    <FormHelperText error sx={{ ml: 4 }}>
                      {formik.errors.verified}
                    </FormHelperText>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <CancelButton action={() => handleCancel()}>
                    Cancel
                  </CancelButton>
                  <SubmitButton disabled={loading} type="submit">
                    {loading ? "Confirming..." : "Confirm Delivery"}
                  </SubmitButton>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </Box>
      }
    />
  );
};

export default VerifyAndSale;
